var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-accordion-item",class:{
    'border-b border-t border-ink-200 first:border-0 last:border-0 hover:bg-ink-300': _vm.showBorders,
    'text-vanilla-200': !_vm.isDisabled,
    'text-slate': _vm.isDisabled
  }},[_vm._t("title",function(){return [_c('div',{staticClass:"group flex items-center transition-all duration-700 ease-in-out",class:{
        'cursor-not-allowed': _vm.isDisabled,
        'cursor-pointer': !_vm.isDisabled && !_vm.isList
      },on:{"click":function($event){return _vm.toggleAccordion()}}},[_c('span',{staticClass:"flex-1 font-medium"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('z-icon',{staticClass:"duration-DEFAULT group transform stroke-1.5 transition-all ease-in-out",class:[
          _vm.accordionHeaderAnimations,
          {
            'rotate-90 text-vanilla-200': _vm.open,
            'text-slate': _vm.isDisabled,
            'group-hover:text-vanilla-200': !_vm.isDisabled,
            hidden: _vm.isList
          }
        ],attrs:{"icon":"chevron-right","color":"slate","size":"medium"}})],1)]},{"open":_vm.open,"toggleAccordion":_vm.toggleAccordion}),_vm._v(" "),_c('div',{staticClass:"text-sm leading-6 transition-max-height duration-300 ease-in-out",class:[
      _vm.open ? (_vm.spanCustomHeight ? _vm.customMaxHeight : 'max-h-52') : 'max-h-0',
      _vm.allowOverflow ? 'overflow-auto' : 'overflow-hidden',
      { 'max-h-full': _vm.isList }
    ]},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }